import { createFileRoute } from "@tanstack/react-router";
import { HowToUseCertificationPage } from "~/components/how-to-use/how-to-use-certification-page";

export const Route = createFileRoute(
  "/_protected/apply/how-to-use/$certificationNumber",
)({
  component: HowToUseCertification,
});

function HowToUseCertification() {
  const { certificationNumber } = Route.useParams();
  return <HowToUseCertificationPage certificationNumber={certificationNumber} />;
}
